import GruposProductos from "./GruposProductos";

export default GruposProductos;
